import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

interface Props {
  icon: string,
  spin?: boolean,
  type?: string | null,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    icon: null,
    spin: { type: Boolean, default: false },
    type: { default: null }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { icon: string, spin: boolean, type: string | null };





if (props.type
    && !['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'link'].includes(props.type)) {
  throw new Error(`Props value 'type' (${props.type})`)
}

const classObject = computed(() => {
  const result: { [key: string]: boolean } = {}

  if (props.type) {
    result[`text-${props.type}`] = true
  }

  return result
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_component_font_awesome_icon, {
    icon: props.icon,
    spin: props.spin,
    class: _normalizeClass(_unref(classObject)),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, null, 8, ["icon", "spin", "class"]))
}
}

})